import {MutationTree} from 'vuex';
import {PartnerUsersState} from './types';

export const mutations: MutationTree<PartnerUsersState> = {
  pushPartnerUsers(state, data) {
    state.partnerUsers = state.partnerUsers.concat(data);
  },
  setPartnerUsers(state, data) {
    state.partnerUsers = data;
  },
  setPartnerUserItem(state, data) {
    state.partnerUserItem = data;
  },
};
